(() => {
  const zeroDecimal = new Set([
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
  ]);

  function formatPrice(minor, currency) {
    const n = Number(minor);
    if (!Number.isFinite(n)) return '0 EUR';
    const major = zeroDecimal.has(currency) ? Math.round(n) : n / 100;
    const formatted = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: Number.isInteger(major) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(major);
    return `${formatted} EUR`;
  }

  /** Shopify storefront filters expect major-unit numbers, e.g. 120 or 119.99 — not "120,00". */
  function formatSubmit(minor, currency) {
    const n = Number(minor);
    if (!Number.isFinite(n)) return '';
    if (zeroDecimal.has(currency)) return String(Math.round(n));
    const major = n / 100;
    if (Number.isInteger(major)) return String(major);
    return major.toFixed(2);
  }

  function logPriceSubmit({ minSlider, maxSlider, gteInput, lteInput, form }) {
    const formData = {};
    if (form instanceof HTMLFormElement) {
      for (const [key, value] of new FormData(form).entries()) {
        if (key in formData) {
          const current = formData[key];
          formData[key] = Array.isArray(current) ? [...current, value] : [current, value];
        } else {
          formData[key] = value;
        }
      }
    }
    console.log('[PRICE FILTER SUBMIT]', {
      minSlider,
      maxSlider,
      gteInput,
      lteInput,
      formData,
    });
  }

  function syncSlider(rangeEl, { commitInputs = true } = {}) {
    const wrap = rangeEl.closest('.sr-price-slider');
    if (!wrap) return;

    const facet = wrap.closest('price-facet-component');
    const minRange = wrap.querySelector('.sr-price-slider__range--min');
    const maxRange = wrap.querySelector('.sr-price-slider__range--max');
    if (!(minRange instanceof HTMLInputElement) || !(maxRange instanceof HTMLInputElement)) return;

    const ceiling = Number(wrap.dataset.max || maxRange.max || 0);
    const currency = wrap.dataset.currency || 'EUR';
    let min = Number(minRange.value);
    let max = Number(maxRange.value);

    if (min > max) {
      if (rangeEl === minRange) min = max;
      else max = min;
      minRange.value = String(min);
      maxRange.value = String(max);
    }

    const start = ceiling > 0 ? (min / ceiling) * 100 : 0;
    const end = ceiling > 0 ? (max / ceiling) * 100 : 100;
    wrap.style.setProperty('--sr-price-start', `${start}%`);
    wrap.style.setProperty('--sr-price-end', `${end}%`);

    const minLabel = wrap.querySelector('.sr-price-slider__label--min');
    const maxLabel = wrap.querySelector('.sr-price-slider__label--max');
    if (minLabel) minLabel.textContent = formatPrice(min, currency);
    if (maxLabel) maxLabel.textContent = formatPrice(max, currency);

    if (!commitInputs || !facet) return;
    const minInput = facet.querySelector('[name="filter.v.price.gte"]');
    const maxInput = facet.querySelector('[name="filter.v.price.lte"]');
    if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;

    minInput.value = min <= 0 ? '' : formatSubmit(min, currency);
    maxInput.value = max >= ceiling ? '' : formatSubmit(max, currency);

    logPriceSubmit({
      minSlider: min,
      maxSlider: max,
      gteInput: minInput.value,
      lteInput: maxInput.value,
      form: wrap.closest('form'),
    });
  }

  function onSliderEvent(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.classList.contains('sr-price-slider__range')) return;
    syncSlider(target, { commitInputs: true });
  }

  function commitDrawerPrice(root = document) {
    root.querySelectorAll(':is(.sr-page, .cl-page) .facets--drawer .sr-price-slider__range--min').forEach((input) => {
      if (input instanceof HTMLInputElement) syncSlider(input, { commitInputs: true });
    });
  }

  document.addEventListener('input', onSliderEvent, true);
  document.addEventListener('change', onSliderEvent, true);

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const apply = target.closest(':is(.sr-page, .cl-page) .facets--drawer .facets__see-results');
      if (!apply) return;
      commitDrawerPrice();
      const formComponent = apply.closest('dialog')?.querySelector('facets-form-component');
      if (formComponent && typeof formComponent.updateFilters === 'function') {
        formComponent.updateFilters();
      }
    },
    true
  );

  function bindSlider(wrap) {
    if (!(wrap instanceof HTMLElement) || wrap.dataset.srPriceBound === 'true') return;
    wrap.dataset.srPriceBound = 'true';
    wrap.querySelectorAll('.sr-price-slider__range').forEach((input) => {
      input.addEventListener('input', onSliderEvent);
      input.addEventListener('change', onSliderEvent);
    });
    const minRange = wrap.querySelector('.sr-price-slider__range--min');
    if (minRange instanceof HTMLInputElement) syncSlider(minRange, { commitInputs: false });
  }

  function initSliders(root = document) {
    root.querySelectorAll('.sr-price-slider').forEach(bindSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSliders());
  } else {
    initSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initSliders(event.target);
  });
  document.addEventListener('filter:update', () => {
    requestAnimationFrame(() => initSliders());
  });
  document.addEventListener(
    'toggle',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
      if (!dialog.classList.contains('facets--drawer')) return;
      initSliders(dialog);
    },
    true
  );
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.closest('.sr-all-filters')) return;
      requestAnimationFrame(() => initSliders());
    },
    true
  );
})();
